import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const FOOTER_LINKS = [
  {
    heading: "Navigation",
    links: [
      { label: "Home", to: "/" },
      { label: "Capabilities", to: "/capabilities" },
      { label: "Sectors", to: "/sectors" },
      { label: "Featured Products & Services", to: "/featured" },
      { label: "Leadership", to: "/leadership" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    heading: "Capabilities",
    links: [
      { label: "Strategic Sourcing", to: "/capabilities" },
      { label: "Government Engagement", to: "/capabilities" },
      { label: "Capture Support", to: "/capabilities" },
      { label: "Technical Diligence", to: "/capabilities" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-[hsl(218,60%,10%)] text-white" data-testid="site-footer">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_cortes-execution/artifacts/im0ztelm_cortes_logo_transparent.png"
                alt="Cortes Industries"
                className="w-9 h-9 object-contain brightness-0 invert"
              />
              <span className="text-base font-bold tracking-tight" style={{ fontFamily: 'var(--font-display)' }}>
                Cortes Industries
              </span>
            </div>
            <p className="text-sm text-white/65 leading-relaxed mb-6 max-w-[260px]">
              Procurement and contracting execution for outcome-driven programs.
            </p>
            <div className="space-y-3 text-sm text-white/65">
              <a
                href="mailto:contact@cortesindustries.com"
                className="flex items-center gap-2.5 hover:text-[hsl(41,47%,61%)] transition-colors"
              >
                <Mail className="w-4 h-4 shrink-0" />
                contact@cortesindustries.com
              </a>
              <a
                href="tel:+12022022552"
                className="flex items-center gap-2.5 hover:text-[hsl(41,47%,61%)] transition-colors"
              >
                <Phone className="w-4 h-4 shrink-0" />
                +1-202-202-2552
              </a>
              <div className="flex items-center gap-2.5">
                <MapPin className="w-4 h-4 shrink-0" />
                Salt Lake City, Utah
              </div>
            </div>
          </div>

          {/* Link Columns */}
          {FOOTER_LINKS.map((group) => (
            <div key={group.heading}>
              <h4
                className="text-xs font-semibold uppercase tracking-[0.14em] text-white/50 mb-4"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                {group.heading}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-white/70 hover:text-[hsl(41,47%,61%)] transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Sectors Column */}
          <div>
            <h4
              className="text-xs font-semibold uppercase tracking-[0.14em] text-white/50 mb-4"
              style={{ fontFamily: 'var(--font-display)' }}
            >
              Sectors
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/sectors" className="text-sm text-white/70 hover:text-[hsl(41,47%,61%)] transition-colors">
                  Energy & Emerging Applications
                </Link>
              </li>
              <li>
                <Link to="/sectors" className="text-sm text-white/70 hover:text-[hsl(41,47%,61%)] transition-colors">
                  Critical Materials & Supply Chains
                </Link>
              </li>
              <li>
                <Link to="/sectors" className="text-sm text-white/70 hover:text-[hsl(41,47%,61%)] transition-colors">
                  Industrial Infrastructure
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>&copy; {new Date().getFullYear()} Cortes Industries, LLC. All rights reserved.</p>
          <p>Confidential</p>
        </div>
      </div>
    </footer>
  );
}
